var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c(
        "article",
        {
          staticClass: "cmp cmp-product-thumb",
          attrs: {
            "data-testing":
              _vm.item && _vm.item.variation ? _vm.item.variation.id : null
          }
        },
        [
          _c(
            "div",
            { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
            [
              _c("div", { staticClass: "thumb-image" }, [
                _c(
                  "div",
                  { staticClass: "prop-1-1" },
                  [
                    _vm._t("item-image", [
                      _c("category-image-carousel", {
                        ref: "categoryImageCarousel",
                        attrs: {
                          "image-urls-data": _vm._f("itemImages")(
                            _vm.item.images,
                            _vm.imageUrlAccessor
                          ),
                          alt: _vm._f("itemName")(_vm.item),
                          title: _vm._f("itemName")(_vm.item),
                          "item-url": _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          ),
                          "enable-carousel":
                            _vm.$ceres.config.item.enableImageCarousel,
                          "disable-carousel-on-mobile":
                            _vm.disableCarouselOnMobile
                        }
                      })
                    ])
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _vm._t("store-special", [
                _vm.storeSpecial ||
                _vm.item.variation.bundleType === "bundle" ||
                _vm.item.item.itemType === "set" ||
                _vm.item.prices.rrp
                  ? _c("item-store-special", {
                      attrs: {
                        "store-special": _vm.storeSpecial,
                        "recommended-retail-price": _vm.item.prices.rrp,
                        "variation-retail-price": _vm.item.prices.default,
                        "special-offer-price": _vm.item.prices.specialOffer,
                        "decimal-count": _vm.decimalCount,
                        "bundle-type": _vm.item.variation.bundleType,
                        "item-type": _vm.item.item.itemType
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._t("item-details", [
                _c(
                  "div",
                  { staticClass: "thumb-content" },
                  [
                    _c("div", { staticClass: "small text-grey mb-1 mr-4" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm.$translate("Phywe::Template.globalArtikelNr")
                          )
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removepack")(_vm.item.variation.number)
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "thumb-title small",
                        class: {
                          "stretched-link":
                            _vm.$ceres.config.global.shippingCostsCategoryId ==
                            0
                        },
                        attrs: {
                          href: _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("itemName")(_vm.item)) +
                            "\n                  "
                        ),
                        _vm.item.texts.name3 && _vm.item.texts.name3 !== "N / A"
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "font-weight-bold mb-2 d-none d-lg-inline-block cat-slogan n3"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.item.texts.name3) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.item.groupedAttributes, function(attribute) {
                          return _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Ceres::Template.itemGroupedAttribute",
                                  attribute
                                )
                              )
                            )
                          ])
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.item.prices.default.price.value > 0
                      ? [
                          _c(
                            "div",
                            { staticClass: "thumb-meta mt-2" },
                            [
                              _vm._t("before-prices"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "prices" },
                                [
                                  _vm.item.prices.rrp &&
                                  _vm.item.prices.rrp.price.value > 0 &&
                                  _vm.item.prices.rrp.price.value >
                                    _vm.item.prices.default.unitPrice.value
                                    ? _c(
                                        "div",
                                        { staticClass: "price-view-port" },
                                        [
                                          _vm.item.prices.specialOffer
                                            ? _c(
                                                "del",
                                                { staticClass: "crossprice" },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "itemCrossPrice"
                                                        )(
                                                          _vm.item.prices
                                                            .default.unitPrice
                                                            .formatted,
                                                          true
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "del",
                                                { staticClass: "crossprice" },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "itemCrossPrice"
                                                        )(
                                                          _vm.item.prices.rrp
                                                            .unitPrice.formatted
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.variation.unitsContained > 1
                                    ? [
                                        _c("div", { staticClass: "price" }, [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Phywe::Template.globalAbPreis"
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  _vm.item.prices.default
                                                    .unitPrice.value /
                                                    _vm.item.variation
                                                      .unitsContained
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ])
                                      ]
                                    : [
                                        _c("div", { staticClass: "price" }, [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                _vm._f("specialOffer")(
                                                  _vm.item.prices.default
                                                    .unitPrice.formatted,
                                                  _vm.item.prices,
                                                  "unitPrice",
                                                  "formatted"
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ])
                                      ]
                                ],
                                2
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._t("after-prices")
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ])
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }